import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsScheduled.styles'

type Props = {}

function ReportsScheduledPage(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'pages', 'Scheduled')

  return (
    <div className={classes.root} data-testid={p('title')}>
      {pt('title')}
    </div>
  )
}

export default ReportsScheduledPage
